import {AxiosInstance} from 'axios'
import MyAxiosInstancePriceResearch from './axiosInstancePriceResearch'
import {
    ConsultaDetail,
    ConsultaList,
    ConsultaOut,
    FornecedorBuscaOut,
} from '../types/radarFornecedor'

export class RadarFornecedorApiService {
    private api: AxiosInstance

    constructor() {
        this.api = MyAxiosInstancePriceResearch
    }

    // Período: decisão de produto (23/07/2026) — o Radar cobre SEMPRE os últimos 5 anos;
    // o front não envia periodo_meses (o backend aplica o default de 60 meses).
    async criarConsulta(cnpj: string, nome?: string): Promise<ConsultaOut> {
        const {data} = await this.api.post('/fornecedores', {
            cnpj,
            nome: nome || undefined,
        })
        return data
    }

    async buscarPorNome(nome: string): Promise<FornecedorBuscaOut> {
        const {data} = await this.api.get('/fornecedores/buscar', {
            params: {nome},
        })
        return data
    }

    async getConsulta(id: string): Promise<ConsultaDetail> {
        const {data} = await this.api.get(`/fornecedores/${id}`)
        return data
    }

    async listarConsultas(limit = 20, offset = 0): Promise<ConsultaList> {
        const {data} = await this.api.get('/fornecedores', {
            params: {limit, offset},
        })
        return data
    }

    async removerConsulta(id: string): Promise<void> {
        await this.api.delete(`/fornecedores/${id}`)
    }

    async exportarPdf(id: string): Promise<Blob> {
        const {data} = await this.api.get(`/fornecedores/${id}/pdf`, {
            responseType: 'blob',
        })
        return data
    }

    // Dispara SOB DEMANDA as consultas pagas de certidões/protestos (202 + push).
    async solicitarCertidoes(id: string): Promise<ConsultaOut> {
        const {data} = await this.api.post(`/fornecedores/${id}/certidoes`)
        return data
    }

    // PDF da Consulta Consolidada do TCU — emitido AO VIVO pelo backend (carimbo do dia).
    async baixarCertidaoTcu(id: string): Promise<Blob> {
        const {data} = await this.api.get(`/fornecedores/${id}/certidao-tcu.pdf`, {
            responseType: 'blob',
        })
        return data
    }
}
